import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Plane, ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n";
import { LEGAL } from "@/legalContent";

const SLUGS = { "/termeni": "terms", "/confidentialitate": "privacy", "/cookies": "cookies" };

export default function Legal() {
  const { pathname } = useLocation();
  const { lang, t } = useLang();
  const key = SLUGS[pathname] || "terms";
  const doc = LEGAL[lang][key];

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="min-h-screen bg-stone-50" data-testid="legal-page">
      <header className="bg-stone-50/80 backdrop-blur-xl border-b border-stone-200/60">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-brand">
            <span className="grid place-items-center h-9 w-9 rounded-xl bg-sky-700 text-white"><Plane className="h-5 w-5 -rotate-45" /></span>
            <span className="font-head font-extrabold text-xl tracking-tight text-stone-900">Zbor<span className="text-sky-700">Help</span></span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-stone-600 hover:text-sky-700" data-testid="legal-back">
            <ArrowLeft className="h-4 w-4" /> {lang === "ro" ? "Înapoi" : "Back"}
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-head font-extrabold text-3xl sm:text-4xl tracking-tight text-stone-900">{doc.title}</h1>
        <p className="mt-2 text-sm text-stone-500">{doc.updated}</p>
        <div className="mt-10 space-y-8">
          {doc.body.map(([h, p], i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-head font-semibold text-xl text-stone-900">{h}</h2>
              <p className="mt-2 text-stone-600 leading-relaxed">{p}</p>
            </section>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap gap-4 text-sm">
          <Link to="/termeni" className="text-sky-700 hover:underline">{t.footer.terms}</Link>
          <Link to="/confidentialitate" className="text-sky-700 hover:underline">{t.footer.privacy}</Link>
          <Link to="/cookies" className="text-sky-700 hover:underline">{t.footer.cookies}</Link>
        </div>
      </main>
    </div>
  );
}
